import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/workspaces/$id/')({
	beforeLoad: ({ params }) => {
		throw redirect({ to: '/workspaces/$id/nodes', params: { id: params.id } })
	}
})
